// Format currency
export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};

// Format number with commas
export const formatNumber = (num) => {
  if (!num && num !== 0) return '0';
  const roundedNum = Math.round(Number(num));
  return roundedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Calculate days passed from date
export const daysPassedFromCurrentDate = (dateStr) => {
  try {
    const inputDate = new Date(dateStr);
    const currentDate = new Date();
    const timeDifference = currentDate - inputDate;
    const millisecondsInDay = 1000 * 60 * 60 * 24;
    const daysPassed = Math.floor(timeDifference / millisecondsInDay);
    return daysPassed;
  } catch (error) {
    return 0;
  }
};

// Format date
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

// Validate username (no @ required - will be added automatically)
export const validateUsername = (username) => {
  if (!username) return false;
  // Remove @ if present, then validate
  const cleanUsername = username.replace(/^@/, '');
  // Username should be 3-20 alphanumeric characters (including underscores)
  const regex = /^[a-zA-Z0-9_]{3,20}$/;
  return regex.test(cleanUsername);
};

// Validate PIN
export const validatePin = (pin) => {
  if (!pin) return false;
  // PIN should be exactly 6 digits
  const regex = /^\d{6}$/;
  return regex.test(pin);
};

// Validate email
export const validateEmail = (email) => {
  if (!email) return false;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

// Copy to clipboard
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};

// Get user from localStorage
export const getStoredUser = () => {
  try {
    const userData = localStorage.getItem('modanmic_user');
    if (!userData || userData === 'undefined') return null;
    return JSON.parse(userData);
  } catch (error) {
    console.error('Error getting stored user:', error);
    return null;
  }
};

// Save user to localStorage
export const saveUser = (userData) => {
  try {
    localStorage.setItem('modanmic_user', JSON.stringify(userData));
    return true;
  } catch (error) {
    console.error('Error saving user:', error);
    return false;
  }
};

// Clear user from localStorage
export const clearUser = () => {
  try {
    localStorage.removeItem('modanmic_user');
    return true;
  } catch (error) {
    console.error('Error clearing user:', error);
    return false;
  }
};

// Calculate withdrawal waiting period
export const calculateWithdrawalDays = (registrationDate) => {
  const daysPassed = daysPassedFromCurrentDate(registrationDate);
  const daysRemaining = Math.max(0, 7 - daysPassed);
  return daysRemaining;
};

// Parse accountBalance string ("$491366.22") → number (491366.22)
// Works whether the value is already a number or a "$x,xxx.xx" string
export const parseAccountBalance = (rawBalance) => {
  if (!rawBalance && rawBalance !== 0) return 0;
  if (typeof rawBalance === 'number') return rawBalance;
  // Strip "$" and commas then parse
  const cleaned = String(rawBalance).replace(/[$,]/g, '').trim();
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};
